module.exports = __webpack_public_path__ + "img/warning.48acde3b.gif";